import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

const EatinIcon = React.forwardRef<SVGSVGElement, Props>((props, ref) => (
  <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
    <path
      d="M13.5072 3C13.5072 2.44772 13.0595 2 12.5072 2C11.9549 2 11.5072 2.44772 11.5072 3V6C11.5072 6.55228 11.9549 7 12.5072 7C13.0595 7 13.5072 6.55228 13.5072 6V3Z"
      fill="#1A1A1A"
    />
    <path
      d="M20.5072 9C21.6118 9 22.5273 9.90415 22.3079 10.9867C22.1805 11.6152 21.9926 12.2315 21.746 12.8268C21.2435 14.0401 20.5069 15.1425 19.5783 16.0711C18.6497 16.9997 17.5473 17.7362 16.3341 18.2388C15.1208 18.7413 13.8204 19 12.5072 19C11.194 19 9.89365 18.7413 8.68039 18.2388C7.46713 17.7362 6.36474 16.9997 5.43616 16.0711C4.50757 15.1425 3.77098 14.0401 3.26843 12.8268C3.02184 12.2315 2.83396 11.6152 2.70656 10.9867C2.48712 9.90415 3.40265 9 4.50722 9L20.5072 9Z"
      fill="#1A1A1A"
    />
    <path
      d="M5.50722 22C5.50722 21.4477 5.95494 21 6.50722 21H18.5072C19.0595 21 19.5072 21.4477 19.5072 22C19.5072 22.5523 19.0595 23 18.5072 23H6.50722C5.95494 23 5.50722 22.5523 5.50722 22Z"
      fill="#1A1A1A"
    />
    <path
      d="M8.50722 2C9.05951 2 9.50722 2.44772 9.50722 3V6C9.50722 6.55228 9.05951 7 8.50722 7C7.95494 7 7.50722 6.55228 7.50722 6V3C7.50722 2.44772 7.95494 2 8.50722 2Z"
      fill="#1A1A1A"
    />
    <path
      d="M17.5072 3C17.5072 2.44772 17.0595 2 16.5072 2C15.9549 2 15.5072 2.44772 15.5072 3V6C15.5072 6.55228 15.9549 7 16.5072 7C17.0595 7 17.5072 6.55228 17.5072 6V3Z"
      fill="#1A1A1A"
    />
  </svg>
));

EatinIcon.displayName = 'EatinIcon';

export default EatinIcon;
